import Input from '../formik/input'
import InputPassword from '../formik/input-password'
import InputRadio from '../formik/input-radio'
import InputUpload from '../formik/input-upload'
import InputGroup from '../formik/input-group'
import InputMask from '../formik/input-mask'
import InputArray from '../formik/input-array'
import InputCheck from '../formik/input-check'
import InputSwitch from '../formik/input-switch'
import InputPhone from '../formik/input-phone'
import MultipleInput from '../formik/multiple-input'
import Textarea from '../formik/textarea'
import Button from '../formik/button'
import Link from '../formik/link'
import Title from '../formik/title'
import Select from '../formik/select'
import SelectChecklist from '../formik/select-checklist'
import Warning from '../formik/warning'

const ComponentsList = {
  Title,
  Input,
  InputRadio,
  InputUpload,
  InputPassword,
  InputGroup,
  InputMask,
  InputCheck,
  InputSwitch,
  Select,
  Textarea,
  Button,
  Link,
  InputArray,
  MultipleInput,
  SelectChecklist,
  InputPhone,
  Warning,
}

export default ComponentsList
